<template>
  <div>
    <!-- 顶部tab切换 -->
    <div class="function-nav">
      <div class="nav-tabs">
        <span v-for="tab in tabs" :key="tab.label" class="tab" :class="{active: activeTab === tab.label}" @click="switchTab(tab)">{{ tab.label }}</span>
      </div>
      <div class="refresh-btn">
        <button @click="onRefresh" style="background:#4caf50;color:#fff;border:none;padding:4px 16px;border-radius:4px;">刷新</button>
      </div>
    </div>
    
    <!-- 筛选区 -->
    <div class="search-section search-section-new">
      <form class="search-form-2x2">
        <div class="form-fields">
          <div class="form-item">
            <label>设备类型：</label>
            <select class="form-input" v-model="query.fac_type">
              <option value="">全部</option>
              <option value="0">温湿度表</option>
              <option value="1">压力</option>
            </select>
          </div>
          <div class="form-item">
            <label>所属厂区：</label>
            <select class="form-input" v-model="query.factory_area">
              <option value="">全部</option>
              <option v-for="area in options.factory_area" :key="area" :value="area">{{ area }}</option>
            </select>
          </div>
          <div class="form-item">
            <label>所属楼号：</label>
            <select class="form-input" v-model="query.building_number">
              <option value="">全部</option>
              <option v-for="building in options.building_number" :key="building" :value="building">{{ building }}</option>
            </select>
          </div>
          <div class="form-item">
            <label>所属楼层：</label>
            <select class="form-input" v-model="query.floor">
              <option value="">全部</option>
              <option v-for="floor in options.floor" :key="floor" :value="floor">{{ floor }}</option>
            </select>
          </div>
          <div class="form-item">
            <label>开始日期：</label>
            <input class="form-input" type="date" v-model="query.start_date" placeholder="" />
          </div>
          <div class="form-item">
            <label>结束日期：</label>
            <input class="form-input" type="date" v-model="query.end_date" placeholder="" />
          </div>

        </div>
        <div class="form-btns">
          <button type="button" class="search-btn-green" @click="onSearch">搜索</button>
          <button type="button" class="search-btn-green" @click="printData">打印</button>
          <!-- <button type="button" class="clear-btn" @click="onClear">清空</button> -->
        </div>
      </form>
    </div>
    
    <!-- 新增按钮 -->
    <div style="margin: 16px 0 8px 8px;">
      <button class="search-btn-green" @click="openAddForm" style="background:#4caf50;">
        <span style="font-size:18px;font-weight:bold;"></span> 新增维修记录
      </button>
    </div>
    
    <!-- 表格 -->
    <div class="data-section">
      <div class="table-container">
        <table class="data-table">
          <thead>
            <tr>
              <th>序号</th>
              <th>维修编号</th>
              <th>设备编号</th>
              <th>设备名称</th>
              <th>设备类型</th>
              <th>安装位置</th>
              <th>申请人</th>
              <th>申请日期</th>
              <th>故障描述</th>
              <th>解决状态</th>
              <th>解决人员</th>
              <th>解决日期</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="loading">
              <td colspan="13" style="text-align:center;color:#bbb;">数据加载..</td>
            </tr>
            <tr v-else-if="maintenanceList.length === 0">
              <td colspan="13" style="text-align:center;color:#bbb;">暂无数据</td>
            </tr>
            <template v-if="maintenanceList.length > 0">
              <tr v-for="(item, idx) in maintenanceList" :key="item.maintenance_id">
                <td>{{ (page-1)*pageSize + idx + 1 }}</td>
                <td>{{ item.maintenance_id }}</td>
                <td>{{ item.fac_id }}</td>
                <td>{{ item.fac_name }}</td>
                <td>{{ item.fac_type }}</td>
                <td>{{ item.install_area }}</td>
                <td>{{ item.applicant }}</td>
                <td>{{ formatDateForDisplay(item.applicant_date) }}</td>
                <td>{{ item.fault_description }}</td>
                <td>
                  <span v-if="item.resolution_state === '待处理'" style="color:#fff;background:#e74c3c;padding:2px 8px;border-radius:4px;font-size:13px;">待处理</span>
                  <span v-else-if="item.resolution_state === '已处理'" style="color:#fff;background:#4caf50;padding:2px 8px;border-radius:4px;font-size:13px;">已处理</span>
                  <span v-else-if="item.resolution_state === '已解决'" style="color:#fff;background:#4caf50;padding:2px 8px;border-radius:4px;font-size:13px;">已解决</span>
                  <span v-else-if="item.resolution_state === '已关闭'" style="color:#fff;background:#95a5a6;padding:2px 8px;border-radius:4px;font-size:13px;">已关闭</span>
                  <span v-else style="color:#666;background:#f5f5f5;padding:2px 8px;border-radius:4px;font-size:13px;">{{ item.resolution_state || '未设置' }}</span>
                </td>
                <td>{{ item.resolution_people }}</td>
                <td>{{ formatDateForDisplay(item.resolution_date) }}</td>
                <td>
                  <div class="table-action-btns">
                    <button class="search-btn-green" @click="showMaintenanceDetail(item)">详情</button>
                    <button class="search-btn-green" @click="showMaintenanceEdit(item)">编辑</button>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      
      <!-- 分页 -->
      <div class="pagination">
        <button class="page-btn" :disabled="page===1" @click="changePage(1)">«</button>
        <button class="page-btn" :disabled="page===1" @click="changePage(page-1)">&lt;</button>
        <span v-for="p in displayPages" :key="p">
          <button class="page-btn" :class="{active:page===p}" @click="changePage(p)">{{p}}</button>
        </span>
        <button class="page-btn" :disabled="page===totalPages" @click="changePage(page+1)">&gt;</button>
        <button class="page-btn" :disabled="page===totalPages" @click="changePage(totalPages)">»</button>
        <div class="page-jump">
          <input type="text" v-model="pageInput" style="width:50px;" />
          <button class="jump-btn" @click="jumpPage">跳转</button>
        </div>
      </div>
    </div>
    
    <!-- 新增/编辑表单弹窗 -->
    <div v-if="showAddForm" class="modal-mask" style="position:fixed;left:0;top:0;width:100vw;height:100vh;background:#0003;z-index:1000;display:flex;align-items:center;justify-content:center;">
      <div class="modal-content" style="background:#fff;padding:40px 60px 32px 60px;border-radius:8px;min-width:800px;position:relative;">
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:32px;">
          <span style="font-size:22px;color:#1976d2;font-weight:bold;border-bottom:3px solid #1976d2;padding-bottom:4px;">{{ isEditMode ? '编辑维修记录' : '新增维修记录' }}</span>
          <button @click="closeAddForm" style="background:none;border:none;font-size:28px;cursor:pointer;line-height:1;">×</button>
        </div>
        <div style="margin-bottom:24px;padding:12px 16px;background:#f5f5f5;border-radius:6px;color:#666;font-size:14px;text-align:center;">
          <span style="color:#e74c3c;">*</span> 为必填字段，请确保信息完整准确
        </div>
        <form class="edit-form edit-form-centered">
          <div class="edit-form-row">
            <label><span class="required">*</span>维修编号：</label>
            <input v-model="form.maintenance_id" class="form-input" :readonly="isEditMode" :placeholder="isEditMode ? '维修编号不可编辑' : '请输入维修编号'" />
          </div>
          <div class="edit-form-row">
            <label><span class="required">*</span>设备类型：</label>
            <select v-model="form.fac_type" class="form-input" @change="onFacTypeChange">
              <option value="">请选择设备类型</option>
              <option value="0">温湿度表</option>
              <option value="1">压力</option>
            </select>
          </div>
          <div class="edit-form-row">
            <label><span class="required">*</span>所属厂区：</label>
            <select v-model="form.factory_area" class="form-input" @change="onFactoryAreaChange" :disabled="!form.fac_type">
              <option value="">请先选择设备类型</option>
              <option v-for="area in formOptions.factory_area" :key="area" :value="area">{{ area }}</option>
            </select>
          </div>
          <div class="edit-form-row">
            <label><span class="required">*</span>所属楼号：</label>
            <select v-model="form.building_number" class="form-input" @change="onBuildingNumberChange" :disabled="!form.factory_area">
              <option value="">请先选择所属厂区</option>
              <option v-for="building in formOptions.building_number" :key="building" :value="building">{{ building }}</option>
            </select>
          </div>
          <div class="edit-form-row">
            <label><span class="required">*</span>所属楼层：</label>
            <select v-model="form.floor" class="form-input" @change="onFloorChange" :disabled="!form.building_number">
              <option value="">请先选择所属楼号</option>
              <option v-for="floor in formOptions.floor" :key="floor" :value="floor">{{ floor }}</option>
            </select>
          </div>
          <div class="edit-form-row">
            <label><span class="required">*</span>设备编号：</label>
            <select v-model="form.fac_id" class="form-input" @change="onFacIdChange" :disabled="!form.floor">
              <option value="">请先选择所属楼层</option>
              <option v-for="device in deviceOptions" :key="device.fac_id" :value="device.fac_id">
                {{ device.fac_id }} - {{ device.fac_name }}
              </option>
            </select>
          </div>
          <div class="edit-form-row">
            <label><span class="required">*</span>设备名称：</label>
            <input v-model="form.fac_name" class="form-input" placeholder="设备名称将自动填充" readonly />
          </div>
          <div class="edit-form-row">
            <label><span class="required">*</span>安装位置：</label>
            <input v-model="form.install_area" class="form-input" placeholder="安装位置将自动填充" readonly />
          </div>
          <div class="edit-form-row">
            <label><span class="required">*</span>申请人：</label>
            <input v-model="form.applicant" class="form-input" placeholder="请输入申请人" />
          </div>
          <div class="edit-form-row">
            <label><span class="required">*</span>申请日期：</label>
            <input v-model="form.applicant_date" type="date" class="form-input" />
          </div>
          <div class="edit-form-row">
            <label><span class="required">*</span>故障描述：</label>
            <textarea v-model="form.fault_description" class="form-input" placeholder="请输入故障描述" rows="3"></textarea>
          </div>
          <div class="edit-form-row">
            <label>解决状态：</label>
            <select v-model="form.resolution_state" class="form-input">
              <option value="">请选择解决状态</option>
              <option value="待处理">待处理</option>
              <option value="已处理">已处理</option>
              <option value="已解决">已解决</option>
              <option value="已关闭">已关闭</option>
            </select>
          </div>
          <div class="edit-form-row">
            <label>解决描述：</label>
            <textarea v-model="form.resolution_description" class="form-input" placeholder="请输入解决描述" rows="3"></textarea>
          </div>
          <div class="edit-form-row">
            <label>解决人员：</label>
            <input v-model="form.resolution_people" class="form-input" placeholder="请输入解决人员" />
          </div>
          <div class="edit-form-row">
            <label>解决日期：</label>
            <input v-model="form.resolution_date" type="date" class="form-input" />
          </div>
          <!-- <div class="edit-form-row">
            <label>故障照片：</label>
            <div style="display: flex; align-items: center; gap: 12px;">
              <label style="cursor: pointer;">
                <input type="file" @change="onFaultPhotoChange" accept="image/*" style="display: none;" />
                <div v-if="!form.fault_photo_url" style="width: 120px; height: 80px; border: 2px dashed #ddd; border-radius: 8px; display: flex; flex-direction: column; align-items: center; justify-content: center; font-size: 12px; color: #888; background: #fafbfc; transition: all 0.3s;">
                  <div style="font-size: 20px; margin-bottom: 4px;">+</div>
                  <div>点击上传</div>
                </div>
                <img v-else :src="form.fault_photo_url" style="width: 120px; height: 80px; border-radius: 8px; object-fit: cover; border: 2px solid #ddd; cursor: pointer;" @click="previewImage(form.fault_photo_url)" />
              </label>
            </div>
          </div>
          <div class="edit-form-row">
            <label>解决照片：</label>
            <div style="display: flex; align-items: center; gap: 12px;">
              <label style="cursor: pointer;">
                <input type="file" @change="onResolutionPhotoChange" accept="image/*" style="display: none;" />
                <div v-if="!form.resolution_photo_url" style="width: 120px; height: 80px; border: 2px dashed #ddd; border-radius: 8px; display: flex; flex-direction: column; align-items: center; justify-content: center; font-size: 12px; color: #888; background: #fafbfc; transition: all 0.3s;">
                  <div style="font-size: 20px; margin-bottom: 4px;">+</div>
                  <div>点击上传</div>
                </div>
                <img v-else :src="form.resolution_photo_url" style="width: 120px; height: 80px; border-radius: 8px; object-fit: cover; border: 2px solid #ddd; cursor: pointer;" @click="previewImage(form.resolution_photo_url)" />
              </label>
            </div>
          </div> -->
          <div style="display:flex;justify-content:center;margin-top:32px;gap:16px;">
            <button type="button" class="save-btn" @click="onSubmit">保存</button>
            <button type="button" class="clear-btn" @click="closeAddForm">取消</button>
          </div>
        </form>
      </div>
    </div>
    
    <!-- 详情弹窗 -->
    <div v-if="showDetailForm" class="modal-mask" style="position:fixed;left:0;top:0;width:100vw;height:100vh;background:#0003;z-index:1000;display:flex;align-items:center;justify-content:center;">
      <div class="modal-content" style="background:#fff;padding:40px 60px 32px 60px;border-radius:8px;min-width:800px;position:relative;">
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:32px;">
          <span style="font-size:22px;color:#1976d2;font-weight:bold;border-bottom:3px solid #1976d2;padding-bottom:4px;">维修记录详情</span>
          <button @click="closeDetailForm" style="background:none;border:none;font-size:28px;cursor:pointer;line-height:1;">×</button>
        </div>
        <div class="edit-form">
          <div class="edit-form-row">
            <label>维修编号：</label>
            <input :value="form.maintenance_id" class="form-input" readonly />
          </div>
          <div class="edit-form-row">
            <label>设备编号：</label>
            <input :value="form.fac_id" class="form-input" readonly />
          </div>
          <div class="edit-form-row">
            <label>设备名称：</label>
            <input :value="form.fac_name" class="form-input" readonly />
          </div>
          <div class="edit-form-row">
            <label>设备类型：</label>
            <input :value="form.fac_type === '0' ? '温湿度表' : form.fac_type === '1' ? '压力表' : form.fac_type" class="form-input" readonly />
          </div>
          <div class="edit-form-row">
            <label>安装位置：</label>
            <input :value="form.install_area" class="form-input" readonly />
          </div>
          <div class="edit-form-row">
            <label>所属厂区：</label>
            <input :value="form.factory_area" class="form-input" readonly />
          </div>
          <div class="edit-form-row">
            <label>所属楼号：</label>
            <input :value="form.building_number" class="form-input" readonly />
          </div>
          <div class="edit-form-row">
            <label>所属楼层：</label>
            <input :value="form.floor" class="form-input" readonly />
          </div>
          <div class="edit-form-row">
            <label>申请人：</label>
            <input :value="form.applicant" class="form-input" readonly />
          </div>
          <div class="edit-form-row">
            <label>申请日期：</label>
            <input :value="form.applicant_date" class="form-input" readonly />
          </div>
          <div class="edit-form-row">
            <label>故障描述：</label>
            <textarea :value="form.fault_description" class="form-input" readonly rows="3"></textarea>
          </div>
          <div class="edit-form-row">
            <label>解决状态：</label>
            <input :value="form.resolution_state" class="form-input" readonly />
          </div>
          <div class="edit-form-row">
            <label>解决描述：</label>
            <textarea :value="form.resolution_description" class="form-input" readonly rows="3"></textarea>
          </div>
          <div class="edit-form-row">
            <label>解决人员：</label>
            <input :value="form.resolution_people" class="form-input" readonly />
          </div>
          <div class="edit-form-row">
            <label>解决日期：</label>
            <input :value="form.resolution_date" class="form-input" readonly />
          </div>
          <!-- <div class="edit-form-row" v-if="form.fault_photo_url">
            <label>故障照片：</label>
            <img :src="form.fault_photo_url" style="max-width:200px;max-height:150px;border-radius:4px;" />
          </div>
          <div class="edit-form-row" v-if="form.resolution_photo_url">
            <label>解决照片：</label>
            <img :src="form.resolution_photo_url" style="max-width:200px;max-height:150px;border-radius:4px;" />
          </div> -->
        </div>

      </div>
    </div>
    
    <!-- 大图预览弹窗 -->
    <div v-if="showImagePreview" class="modal-mask" style="position:fixed;left:0;top:0;width:100vw;height:100vh;background:#000a;z-index:2000;display:flex;align-items:center;justify-content:center;">
      <div @click.self="closeImagePreview" style="position:fixed;left:0;top:0;width:100vw;height:100vh;"></div>
      <div style="position:relative;z-index:1;">
        <img :src="previewImageUrl" style="max-width:80vw;max-height:80vh;border-radius:8px;box-shadow:0 2px 16px #0008;" />
        <button @click="closeImagePreview" style="position:absolute;top:-32px;right:0;background:none;border:none;font-size:32px;color:#fff;cursor:pointer;">×</button>
      </div>
    </div>
  </div>

</template>

<script>
import { HTTP_CONFIG } from '@/config/config.js'

export default {
  name: 'EnvDevice',
  data() {
    return {
      tabs: [
        { label: '维修记录' }
      ],
      activeTab: '维修记录',
      query: {
        fac_type: '',
        factory_area: '',
        building_number: '',
        floor: '',
        start_date: '',
        end_date: '',
        fac_name: '',
        install_area: ''
      },
      page: 1,
      pageSize: 10,
      pageInput: '1',
      total: 0,
      totalPages: 1,
      showAddForm: false,
      showDetailForm: false,
      isEditMode: false,
      form: {
        maintenance_id: '',
        fac_id: '',
        fac_name: '',
        fac_type: '',
        install_area: '',
        factory_area: '',
        building_number: '',
        floor: '',
        applicant: '',
        applicant_date: '',
        fault_description: '',
        resolution_state: '',
        resolution_description: '',
        resolution_people: '',
        resolution_date: '',
        fault_photo: null,
        resolution_photo: null,
        fault_photo_url: '', // 新增：用于存储图片的 URL
        resolution_photo_url: '' // 新增：用于存储图片的 URL
      },
      maintenanceList: [],
      loading: false,
      options: {
        factory_area: [],
        building_number: [],
        floor: []
      },
      deviceOptions: [], // 设备选项列表
      formOptions: {
        factory_area: [],
        building_number: [],
        floor: []
      },
      
      lastQuery: null,
      showImagePreview: false,
      previewImageUrl: ''
    }
  },
  computed: {
    // 删除 pagedList 计算属性，直接使用 maintenanceList
    // 删除 totalPages 计算属性，使用 data 中的 totalPages
    
    // 新增：生成显示的页码范围，最多显示10页
    displayPages() {
      const total = this.totalPages;
      const current = this.page;
      const maxDisplay = 10;
      
      if (total <= maxDisplay) {
        return Array.from({ length: total }, (_, i) => i + 1);
      }
      
      let start = Math.max(1, current - Math.floor(maxDisplay / 2));
      let end = Math.min(total, start + maxDisplay - 1);
      
      if (end - start + 1 < maxDisplay) {
        start = Math.max(1, end - maxDisplay + 1);
      }
      
      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    }
  },
  watch: {
    'query.fac_type'() {
      this.updateOptions();
    },
    'query.factory_area'() {
      this.updateOptions();
    },
    'query.building_number'() {
      this.updateOptions();
    },
    'query.floor'() {
      this.updateOptions();
    }
  },
  mounted() {
    this.loadData();
    this.fetchOptions();
    // 设置默认申请日期为当前时间
    const now = new Date();
    this.form.applicant_date = now.toISOString().split('T')[0];
    const BeijingTime2 = new Date(new Date() + 8 * 3600 * 1000);
    // const year = BeijingTime2.getFullYear()
    this.query.start_date = "2025" + "-01-01";
    this.query.end_date = BeijingTime2.toISOString().slice(0, 10);
  },
  methods: {
    // 获取所有选项数据
    async fetchOptions() {
      try {
        await Promise.all([
          this.fetchFactoryAreaOptions(),
          this.fetchBuildingNumberOptions(),
          this.fetchFloorOptions()
        ]);
      } catch (error) {
        console.error('获取选项数据失败:', error);
      }
    },

    // 获取厂区选项
    async fetchFactoryAreaOptions() {
      try {
        const params = new URLSearchParams();
        if (this.query.fac_type) params.append('fac_type', this.query.fac_type);
        if (this.query.building_number) params.append('building_number', this.query.building_number);
        if (this.query.floor) params.append('floor', this.query.floor);
        
        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/environment/query_fac_area_list/?${params}`);
        const data = await response.json();
        
        if (data && data.factory_area) {
          this.options.factory_area = Array.from(data.factory_area).filter(Boolean);
          this.formOptions.factory_area = Array.from(data.factory_area).filter(Boolean); // 同步到表单选项
        }
      } catch (error) {
        console.error('获取厂区选项失败:', error);
      }
    },

    // 获取楼号选项
    async fetchBuildingNumberOptions() {
      try {
        const params = new URLSearchParams();
        if (this.query.fac_type) params.append('fac_type', this.query.fac_type);
        if (this.query.factory_area) params.append('factory_area', this.query.factory_area);
        if (this.query.floor) params.append('floor', this.query.floor);
        
        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/environment/query_building_number_list/?${params}`);
        const data = await response.json();
        
        if (data && data.building_number) {
          this.options.building_number = Array.from(data.building_number).filter(Boolean);
          this.formOptions.building_number = Array.from(data.building_number).filter(Boolean); // 同步到表单选项
        }
      } catch (error) {
        console.error('获取楼号选项失败:', error);
      }
    },

    // 获取楼层选项
    async fetchFloorOptions() {
      try {
        const params = new URLSearchParams();
        if (this.query.fac_type) params.append('fac_type', this.query.fac_type);
        if (this.query.factory_area) params.append('factory_area', this.query.factory_area);
        if (this.query.building_number) params.append('building_number', this.query.building_number);
        
        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/environment/query_floor_list/?${params}`);
        const data = await response.json();
        
        if (data && data.floor) {
          this.options.floor = Array.from(data.floor).filter(Boolean);
          this.formOptions.floor = Array.from(data.floor).filter(Boolean); // 同步到表单选项
        }
      } catch (error) {
        console.error('获取楼层选项失败:', error);
      }
    },

    // 智能更新选项
    async updateOptions() {
      try {
        const promises = [];
        
        // 如果设备类型变化，需要更新所有相关选项
        if (this.query.fac_type !== this.lastQuery?.fac_type) {
          promises.push(
            this.fetchFactoryAreaOptions(),
            this.fetchBuildingNumberOptions(),
            this.fetchFloorOptions()
          );
        }
        // 如果厂区变化，需要更新楼号、楼层选项
        else if (this.query.factory_area !== this.lastQuery?.factory_area) {
          promises.push(
            this.fetchBuildingNumberOptions(),
            this.fetchFloorOptions()
          );
        }
        // 如果楼号变化，需要更新楼层选项
        else if (this.query.building_number !== this.lastQuery?.building_number) {
          promises.push(this.fetchFloorOptions());
        }
        
        if (promises.length > 0) {
          await Promise.all(promises);
        }
        
        this.lastQuery = { 
          fac_type: this.query.fac_type,
          factory_area: this.query.factory_area,
          building_number: this.query.building_number,
          floor: this.query.floor
        };
      } catch (error) {
        console.error('更新选项失败:', error);
      }
    },

    // 设备类型变化处理
    async onFacTypeChange() {
      this.form.fac_id = '';
      this.form.fac_name = '';
      this.form.install_area = '';
      this.form.factory_area = '';
      this.form.building_number = '';
      this.form.floor = '';
      this.deviceOptions = [];
      this.formOptions.factory_area = [];
      this.formOptions.building_number = [];
      this.formOptions.floor = [];
      
      if (this.form.fac_type) {
        await this.fetchFormOptions();
      }
    },

    // 厂区变化处理
    async onFactoryAreaChange() {
      this.form.fac_id = '';
      this.form.fac_name = '';
      this.form.install_area = '';
      this.form.building_number = '';
      this.form.floor = '';
      this.deviceOptions = [];
      this.formOptions.building_number = [];
      this.formOptions.floor = [];
      
      if (this.form.factory_area) {
        await this.fetchFormOptions();
      }
    },

    // 楼号变化处理
    async onBuildingNumberChange() {
      this.form.fac_id = '';
      this.form.fac_name = '';
      this.form.install_area = '';
      this.form.floor = '';
      this.deviceOptions = [];
      this.formOptions.floor = [];
      
      if (this.form.building_number) {
        await this.fetchFormOptions();
      }
    },

    // 楼层变化处理
    async onFloorChange() {
      this.form.fac_id = '';
      this.form.fac_name = '';
      this.form.install_area = '';
      this.deviceOptions = [];
      
      if (this.form.floor) {
        await this.fetchDeviceOptions();
      }
    },

    // 设备ID变化处理
    onFacIdChange() {
      if (this.form.fac_id) {
        const selectedDevice = this.deviceOptions.find(device => device.fac_id === this.form.fac_id);
        if (selectedDevice) {
          this.form.fac_name = selectedDevice.fac_name || '';
          this.form.install_area = selectedDevice.install_area || '';
        }
      } else {
        this.form.fac_name = '';
        this.form.install_area = '';
      }
    },

    // 获取表单选项数据
    async fetchFormOptions() {
      try {
        const promises = [];
        
        if (this.form.fac_type) {
          promises.push(this.fetchFormFactoryAreaOptions());
        }
        if (this.form.factory_area) {
          promises.push(this.fetchFormBuildingNumberOptions());
        }
        if (this.form.building_number) {
          promises.push(this.fetchFormFloorOptions());
        }
        
        await Promise.all(promises);
      } catch (error) {
        console.error('获取表单选项失败:', error);
      }
    },

    // 获取表单厂区选项
    async fetchFormFactoryAreaOptions() {
      try {
        const params = new URLSearchParams();
        if (this.form.fac_type) params.append('fac_type', this.form.fac_type);
        
        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/environment/query_fac_area_list/?${params}`);
        const data = await response.json();
        
        if (data && data.factory_area) {
          this.formOptions.factory_area = Array.from(data.factory_area).filter(Boolean);
        }
      } catch (error) {
        console.error('获取表单厂区选项失败:', error);
      }
    },

    // 获取表单楼号选项
    async fetchFormBuildingNumberOptions() {
      try {
        const params = new URLSearchParams();
        if (this.form.fac_type) params.append('fac_type', this.form.fac_type);
        if (this.form.factory_area) params.append('factory_area', this.form.factory_area);
        
        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/environment/query_building_number_list/?${params}`);
        const data = await response.json();
        
        if (data && data.building_number) {
          this.formOptions.building_number = Array.from(data.building_number).filter(Boolean);
        }
      } catch (error) {
        console.error('获取表单楼号选项失败:', error);
      }
    },

    // 获取表单楼层选项
    async fetchFormFloorOptions() {
      try {
        const params = new URLSearchParams();
        if (this.form.fac_type) params.append('fac_type', this.form.fac_type);
        if (this.form.factory_area) params.append('factory_area', this.form.factory_area);
        if (this.form.building_number) params.append('building_number', this.form.building_number);
        
        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/environment/query_floor_list/?${params}`);
        const data = await response.json();
        
        if (data && data.floor) {
          this.formOptions.floor = Array.from(data.floor).filter(Boolean);
        }
      } catch (error) {
        console.error('获取表单楼层选项失败:', error);
      }
    },

    // 获取设备选项
    async fetchDeviceOptions() {
      try {
        if (!this.form.fac_type || !this.form.factory_area || !this.form.building_number || !this.form.floor) {
          this.deviceOptions = [];
          return;
        }

        let apiUrl;
        if (this.form.fac_type === '0') {
          apiUrl = `${HTTP_CONFIG.SERVER_ADDR}/environment/query_TempHum_point_message/`;
        } else if (this.form.fac_type === '1') {
          apiUrl = `${HTTP_CONFIG.SERVER_ADDR}/environment/query_pressure_point_message/`;
        } else {
          this.deviceOptions = [];
          return;
        }

        const params = new URLSearchParams();
        params.append('page', 1);
        params.append('per_page', 1000);
        params.append('factory_area', this.form.factory_area);
        params.append('building_number', this.form.building_number);
        params.append('floor', this.form.floor);

        const response = await fetch(`${apiUrl}?${params}`);
        const data = await response.json();
        
        if (data && data.data) {
          this.deviceOptions = data.data.map(item => ({
            fac_id: item.fac_id,
            fac_name: item.fac_name || '未命名',
            install_area: item.install_area || '',
            factory_area: item.factory_area || '',
            building_number: item.building_number || '',
            floor: item.floor || ''
          }));
        } else {
          this.deviceOptions = [];
        }
      } catch (error) {
        console.error('获取设备选项失败:', error);
        this.deviceOptions = [];
      }
    },

    // 通过fac_id查询设备信息
    async fetchDeviceInfoByFacId(facId, facType) {
      try {
        if (!facId || !facType) {
          return null;
        }

        let apiUrl;
        if (facType === '0' || facType === '温湿度表') {
          apiUrl = `${HTTP_CONFIG.SERVER_ADDR}/environment/query_TempHum_point_message/`;
        } else if (facType === '1' || facType === '压力表') {
          apiUrl = `${HTTP_CONFIG.SERVER_ADDR}/environment/query_pressure_point_message/`;
        } else {
          return null;
        }

        const params = new URLSearchParams();
        params.append('page', 1);
        params.append('per_page', 1000);
        params.append('fac_id', facId);

        const response = await fetch(`${apiUrl}?${params}`);
        const data = await response.json();
        
        if (data && data.data && data.data.length > 0) {
          const device = data.data[0];
          return {
            fac_id: device.fac_id,
            fac_name: device.fac_name || '',
            install_area: device.install_area || '',
            factory_area: device.factory_area || '',
            building_number: device.building_number || '',
            floor: device.floor || '',
            fac_type: facType === '温湿度表' ? '0' : facType === '压力表' ? '1' : facType
          };
        }
        return null;
      } catch (error) {
        console.error('查询设备信息失败:', error);
        return null;
      }
    },

    async loadData() {
      this.loading = true;
      try {
        await this.loadMaintenanceData();
      } catch (error) {
        console.error('加载数据失败:', error);
      } finally {
        this.loading = false;
      }
    },
    
    async loadMaintenanceData() {
      try {
        const params = this.buildQueryParams();
        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/environment/query_maintenance/?${params}`);
        const data = await response.json();
        
        if (data && data.data) {
          // 处理图片URL
          this.maintenanceList = data.data.map(item => ({
            ...item,
            fault_photo_url: this.processImageUrl(item.fault_photo_url),
            resolution_photo_url: this.processImageUrl(item.resolution_photo_url)
          }));
          
          // 更新分页信息
          this.total = data.total || this.maintenanceList.length;
          this.totalPages = data.total_pages || Math.max(1, Math.ceil(this.total / this.pageSize));
          // 确保分页输入框与当前页同步
          this.pageInput = this.page.toString();
        } else {
          this.maintenanceList = [];
          this.total = 0;
          this.totalPages = 1;
        }
      } catch (error) {
        console.error('加载维修数据失败:', error);
        this.maintenanceList = [];
        this.total = 0;
        this.totalPages = 1;
      }
    },
    
    buildQueryParams() {
      const params = new URLSearchParams();
      
      if (this.query.fac_type) {
        params.append('fac_type', this.query.fac_type);
      }
      if (this.query.factory_area) {
        params.append('factory_area', this.query.factory_area);
      }
      if (this.query.building_number) {
        params.append('building_number', this.query.building_number);
      }
      if (this.query.floor) {
        params.append('floor', this.query.floor);
      }
      if (this.query.start_date) {
        params.append('start_date', this.query.start_date);
      }
      if (this.query.end_date) {
        params.append('end_date', this.query.end_date);
      }
      if (this.query.fac_name) {
        params.append('fac_name', this.query.fac_name);
      }
      if (this.query.install_area) {
        params.append('install_area', this.query.install_area);
      }
      
      params.append('page', this.page);
      params.append('per_page', this.pageSize);
      
      return params.toString();
    },
    
    switchTab(tab) {
      this.activeTab = tab.label;
      this.page = 1;
      this.loadData();
    },
    
    onSearch() {
      this.page = 1;
      this.pageInput = '1';
      this.loadData();
    },
    
    onRefresh() {
      this.loadData();
    },
    
    onClear() {
      this.query = {
        fac_type: '',
        factory_area: '',
        building_number: '',
        floor: '',
        start_date: '',
        end_date: '',
        fac_name: '',
        install_area: ''
      };
      this.page = 1;
      this.pageInput = '1';
      this.loadData();
      this.updateOptions();
    },
    
    changePage(newPage) {
      if (newPage >= 1 && newPage <= this.totalPages) {
        this.page = newPage;
        this.loadData();
      }
    },
    
    jumpPage() {
      let p = parseInt(this.pageInput);
      if (!isNaN(p) && p >= 1 && p <= this.totalPages) {
        this.page = p;
        this.loadData();
      }
    },
    
    closeAddForm() {
      this.showAddForm = false;
      this.resetForm();
      this.isEditMode = false;
    },
    
    resetForm() {
      this.form = {
        maintenance_id: '',
        fac_id: '',
        fac_name: '',
        fac_type: '',
        install_area: '',
        factory_area: '',
        building_number: '',
        floor: '',
        applicant: '',
        applicant_date: '',
        fault_description: '',
        resolution_state: '',
        resolution_description: '',
        resolution_people: '',
        resolution_date: '',
        fault_photo: null,
        resolution_photo: null,
        fault_photo_url: '', // 新增：用于存储图片的 URL
        resolution_photo_url: '' // 新增：用于存储图片的 URL
      };
      // 设置默认申请日期为当前时间
      const now = new Date();
      this.form.applicant_date = now.toISOString().split('T')[0];
      // 清空设备选项
      this.deviceOptions = [];
      this.formOptions.factory_area = []; // 清空表单联动选项
      this.formOptions.building_number = []; // 清空表单联动选项
      this.formOptions.floor = []; // 清空表单联动选项
    },
    
    // 图片上传处理方法
    onFaultPhotoChange(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (ev) => {
          this.form.fault_photo = ev.target.result; // 存储 base64 数据
          this.form.fault_photo_url = ev.target.result; // 用于显示
          this.$forceUpdate();
        };
        reader.readAsDataURL(file);
      }
    },

    onResolutionPhotoChange(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (ev) => {
          this.form.resolution_photo = ev.target.result; // 存储 base64 数据
          this.form.resolution_photo_url = ev.target.result; // 用于显示
          this.$forceUpdate();
        };
        reader.readAsDataURL(file);
      }
    },

    // 图片预览方法
    previewImage(url) {
      this.previewImageUrl = url;
      this.showImagePreview = true;
    },

    closeImagePreview() {
      this.showImagePreview = false;
      this.previewImageUrl = '';
    },

    // 将base64图片转换为Blob（用于提交）
    dataURLtoBlob(dataURL) {
      const arr = dataURL.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },

    async onSubmit() {
      // 验证必填字段
      if (!this.form.maintenance_id) {
        alert('请输入维修编号');
        return;
      }
      if (!this.form.fac_id) {
        alert('请输入设备编号');
        return;
      }
      if (!this.form.fac_name) {
        alert('请选择设备');
        return;
      }
      if (!this.form.fac_type) {
        alert('请选择设备类型');
        return;
      }
      if (!this.form.install_area) {
        alert('安装位置不能为空');
        return;
      }
              if (!this.form.factory_area) {
          alert('所属厂区不能为空');
          return;
        }
        if (!this.form.building_number) {
          alert('所属楼号不能为空');
          return;
        }
        if (!this.form.floor) {
          alert('所属楼层不能为空');
          return;
        }
      if (!this.form.applicant) {
        alert('请输入申请人');
        return;
      }
      if (!this.form.applicant_date) {
        alert('请选择申请日期');
        return;
      }
              if (!this.form.fault_description) {
          alert('请输入故障描述');
          return;
        }
      
      let submitButton;
      let originalText;
      
      try {
        submitButton = event.target;
        originalText = submitButton.textContent;
        submitButton.textContent = '提交 ..';
        submitButton.disabled = true;
        
        const formData = new FormData();
        formData.append('maintenance_id', this.form.maintenance_id);
        formData.append('fac_id', this.form.fac_id);
        formData.append('fac_name', this.form.fac_name);
        formData.append('fac_type', this.form.fac_type);
        formData.append('install_area', this.form.install_area);
        formData.append('factory_area', this.form.factory_area);
        formData.append('building_number', this.form.building_number);
        formData.append('floor', this.form.floor);
        formData.append('applicant', this.form.applicant);
        formData.append('applicant_date', this.form.applicant_date);
        formData.append('fault_description', this.form.fault_description);
        
        if (this.form.resolution_state) {
          formData.append('resolution_state', this.form.resolution_state);
        }
        if (this.form.resolution_description) {
          formData.append('resolution_description', this.form.resolution_description);
        }
        if (this.form.resolution_people) {
          formData.append('resolution_people', this.form.resolution_people);
        }
        // 只有当解决日期有值时才发送该字段
        if (this.form.resolution_date) {
          formData.append('resolution_date', this.form.resolution_date);
        }
        if (this.form.fault_photo) {
          formData.append('fault_photo', this.form.fault_photo);
        }
        if (this.form.resolution_photo) {
          formData.append('resolution_photo', this.form.resolution_photo);
        }
        
        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/environment/create_maintenance/`, {
          method: 'POST',
          body: formData
        });
        
        const result = await response.json();
        
        if (result.status === 'success') {
          const action = this.isEditMode ? '编辑' : '新增';
          alert(`维修记录${action}成功！`);
          this.closeAddForm();
          this.loadData();
        } else {
          throw new Error(result.message || '操作失败');
        }
        
      } catch (error) {
        console.error('提交失败:', error);
        alert(`操作失败: ${error.message}`);
      } finally {
        if (submitButton && originalText) {
          submitButton.textContent = originalText;
          submitButton.disabled = false;
        }
      }
    },
    
    // 修改详情显示方法
    async showMaintenanceDetail(item) {
      this.form = { 
        ...item,
        fault_photo_url: this.processImageUrl(item.fault_photo_url),
        resolution_photo_url: this.processImageUrl(item.resolution_photo_url)
      };
      
      // 格式化日期，去除毫秒
      if (this.form.applicant_date) {
        this.form.applicant_date = this.formatDateForInput(this.form.applicant_date);
      }
      if (this.form.resolution_date) {
        this.form.resolution_date = this.formatDateForInput(this.form.resolution_date);
      }

      // 通过fac_id查询设备信息并自动填充
      if (this.form.fac_id) {
        const deviceInfo = await this.fetchDeviceInfoByFacId(this.form.fac_id, this.form.fac_type);
        if (deviceInfo) {
          this.form.fac_id = deviceInfo.fac_id; // 确保设备编号被正确设置
          this.form.fac_name = deviceInfo.fac_name;
          this.form.install_area = deviceInfo.install_area;
          this.form.factory_area = deviceInfo.factory_area;
          this.form.building_number = deviceInfo.building_number;
          this.form.floor = deviceInfo.floor;
          this.form.fac_type = deviceInfo.fac_type;
        }
      }

      this.showDetailForm = true;
    },

    // 修改编辑显示方法
    async showMaintenanceEdit(item) {
      this.form = { 
        ...item,
        fault_photo_url: this.processImageUrl(item.fault_photo_url),
        resolution_photo_url: this.processImageUrl(item.resolution_photo_url)
      };
      
      // 格式化日期，去除毫秒
      if (this.form.applicant_date) {
        this.form.applicant_date = this.formatDateForInput(this.form.applicant_date);
      }
      if (this.form.resolution_date) {
        this.form.resolution_date = this.formatDateForInput(this.form.resolution_date);
      }

      // 通过fac_id查询设备信息并自动填充
      if (this.form.fac_id) {
        const deviceInfo = await this.fetchDeviceInfoByFacId(this.form.fac_id, this.form.fac_type);
        if (deviceInfo) {
          // 更新表单数据
          this.form.fac_id = deviceInfo.fac_id;
          this.form.fac_name = deviceInfo.fac_name;
          this.form.install_area = deviceInfo.install_area;
          this.form.factory_area = deviceInfo.factory_area;
          this.form.building_number = deviceInfo.building_number;
          this.form.floor = deviceInfo.floor;
          this.form.fac_type = deviceInfo.fac_type;
          
          // 加载表单选项数据，确保下拉框能正确显示
          await this.loadFormOptionsForEdit();
        }
      }

      this.showAddForm = true;
      this.isEditMode = true;
    },

    // 新增：为编辑模式加载表单选项
    async loadFormOptionsForEdit() {
      try {
        // 加载厂区选项
        if (this.form.fac_type) {
          await this.fetchFormFactoryAreaOptions();
        }
        
        // 加载楼号选项
        if (this.form.factory_area) {
          await this.fetchFormBuildingNumberOptions();
        }
        
        // 加载楼层选项
        if (this.form.building_number) {
          await this.fetchFormFloorOptions();
        }
        
        // 加载设备选项
        if (this.form.floor) {
          await this.fetchDeviceOptions();
        }
      } catch (error) {
        console.error('加载编辑表单选项失败:', error);
      }
    },
    
    openAddForm() {
      this.isEditMode = false;
      this.resetForm();
      this.showAddForm = true;
    },

    closeDetailForm() {
      this.showDetailForm = false;
      this.resetForm();
    },

    // 新增日期格式化方法
    formatDateForInput(dateString) {
      if (!dateString) return '';
      
      // 处理 "2025-08-28 07:19:11.530033" 格式
      if (dateString.includes(' ') && dateString.includes(':')) {
        return dateString.split(' ')[0];
      }
      
      // 如果是完整的日期时间字符串，提取日期部分
      if (dateString.includes('T')) {
        return dateString.split('T')[0];
      }
      
      // 如果已经是 YYYY-MM-DD 格式，直接返回
      if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
        return dateString;
      }
      
      // 其他格式尝试解析
      try {
        const date = new Date(dateString);
        if (!isNaN(date.getTime())) {
          return date.toISOString().split('T')[0];
        }
      } catch (error) {
        console.warn('日期格式解析失败:', dateString);
      }
      
      return dateString;
    },

    // 新增表格显示用的日期格式化方法
    formatDateForDisplay(dateString) {
      if (!dateString) return '';
      
      // 处理 "2025-08-28 07:19:11.530033" 格式
      if (dateString.includes(' ') && dateString.includes(':')) {
        return dateString.split(' ')[0];
      }
      
      // 如果是完整的日期时间字符串，提取日期部分
      if (dateString.includes('T')) {
        return dateString.split('T')[0];
      }
      
      // 如果已经是 YYYY-MM-DD 格式，直接返回
      if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
        return dateString;
      }
      
      // 其他格式尝试解析
      try {
        const date = new Date(dateString);
        if (!isNaN(date.getTime())) {
          return date.toISOString().split('T')[0];
        }
      } catch (error) {
        console.warn('日期格式解析失败:', dateString);
      }
      
      return dateString;
    },

    // 处理图片URL的方法（与AiTraffic.vue保持一致）
    processImageUrl(url) {
      if (!url) return url;
      const matches = url.match('/media.*')
      console.log(matches[0])
      let result = null
      if(matches.length > 0) result = 'https://gdykpt.cn' + matches[0]
      console.log(result)
      return result;
    },

    // 打印方法
    async printData() {
      try {
        console.log('=== 开始打印维修记录数据 ===');
        
        // 构建查询参数，设置per_page为500获取所有数据
        const params = this.buildPrintQueryParams();
        
        console.log('打印查询参数:', params);
        
        // 调用API获取所有数据
        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/environment/query_maintenance/?${params}`);
        const data = await response.json();
        
        let allData = [];
        
        if (data && data.data) {
          allData = data.data.map(item => ({
            maintenance_id: item.maintenance_id,
            fac_id: item.fac_id,
            fac_name: item.fac_name || '未命名',
            fac_type: this.getDeviceTypeName(item.fac_type),
            install_area: item.install_area || '',
            factory_area: item.factory_area || '',
            building_number: item.building_number || '',
            floor: item.floor || '',
            applicant: item.applicant || '',
            applicant_date: this.formatDateForDisplay(item.applicant_date),
            fault_description: item.fault_description || '',
            resolution_state: item.resolution_state || '未设置',
            resolution_people: item.resolution_people || '',
            resolution_date: this.formatDateForDisplay(item.resolution_date)
          }));
        }
        
        console.log('获取到数据条数:', allData.length);
        
        if (allData.length === 0) {
          alert('没有数据可以打印');
          return;
        }
        
        // 创建打印内容
        this.createPrintContent(allData);
        
      } catch (error) {
        console.error('打印数据失败:', error);
        alert('打印失败: ' + error.message);
      }
    },

    // 构建打印查询参数
    buildPrintQueryParams() {
      const params = new URLSearchParams();
      
      if (this.query.fac_type) {
        params.append('fac_type', this.query.fac_type);
      }
      if (this.query.factory_area) {
        params.append('factory_area', this.query.factory_area);
      }
      if (this.query.building_number) {
        params.append('building_number', this.query.building_number);
      }
      if (this.query.floor) {
        params.append('floor', this.query.floor);
      }
      if (this.query.start_date) {
        params.append('start_date', this.query.start_date);
      }
      if (this.query.end_date) {
        params.append('end_date', this.query.end_date);
      }
      if (this.query.fac_name) {
        params.append('fac_name', this.query.fac_name);
      }
      if (this.query.install_area) {
        params.append('install_area', this.query.install_area);
      }
      
      params.append('page', 1);
      params.append('per_page', 500); // 获取所有数据
      
      return params.toString();
    },

    // 获取设备类型名称
    getDeviceTypeName(facType) {
      if (facType === '0') return '温湿度表';
      if (facType === '1') return '压力表';
      return facType || '未知';
    },

    // 创建打印内容
    createPrintContent(data) {
      const printWindow = window.open('', '_blank');
      
      const currentDate = new Date().toLocaleString('zh-CN');
      const searchConditions = this.getSearchConditionsText();
      
      let html = `
        <!DOCTYPE html>
        <html>
        <head>
          <meta charset="UTF-8">
          <title>维修记录打印</title>
          <style>
            body { font-family: Arial, sans-serif; margin: 20px; }
            .header { text-align: center; margin-bottom: 30px; }
            .title { font-size: 24px; font-weight: bold; margin-bottom: 10px; }
            .info { font-size: 14px; color: #666; margin-bottom: 20px; }
            .search-info { background: #f5f5f5; padding: 10px; border-radius: 4px; margin-bottom: 20px; }
            table { width: 100%; border-collapse: collapse; margin-top: 20px; }
            th, td { border: 1px solid #ddd; padding: 8px; text-align: left; font-size: 12px; }
            th { background-color: #f2f2f2; font-weight: bold; }
            .status-tag { padding: 2px 6px; border-radius: 3px; font-size: 11px; }
            .status-pending { background: #e74c3c; color: white; }
            .status-processed { background: #4caf50; color: white; }
            .status-resolved { background: #4caf50; color: white; }
            .status-closed { background: #95a5a6; color: white; }
            .status-unknown { background: #f5f5f5; color: #666; }
            @media print {
              body { margin: 0; }
              .no-print { display: none; }
            }
          </style>
        </head>
        <body>
          <div class="header">
            <div class="title">维修记录报表</div>
            <div class="info">打印时间: ${currentDate}</div>
            <div class="info">数据条数: ${data.length} 条</div>
          </div>
          
          <div class="search-info">
            <strong>查询条件:</strong> ${searchConditions}
          </div>
          
          <table>
            <thead>
              <tr>
                <th>序号</th>
                <th>维修编号</th>
                <th>设备编号</th>
                <th>设备名称</th>
                <th>设备类型</th>
                <th>安装位置</th>
                <th>所属厂区</th>
                <th>所属楼号</th>
                <th>所属楼层</th>
                <th>申请人</th>
                <th>申请日期</th>
                <th>故障描述</th>
                <th>解决状态</th>
                <th>解决人员</th>
                <th>解决日期</th>
              </tr>
            </thead>
            <tbody>
      `;
      
      data.forEach((item, index) => {
        const statusClass = this.getStatusClass(item.resolution_state);
        html += `
          <tr>
            <td>${index + 1}</td>
            <td>${item.maintenance_id}</td>
            <td>${item.fac_id}</td>
            <td>${item.fac_name}</td>
            <td>${item.fac_type}</td>
            <td>${item.install_area}</td>
            <td>${item.factory_area}</td>
            <td>${item.building_number}</td>
            <td>${item.floor}</td>
            <td>${item.applicant}</td>
            <td>${item.applicant_date}</td>
            <td>${item.fault_description}</td>
            <td><span class="status-tag ${statusClass}">${item.resolution_state}</span></td>
            <td>${item.resolution_people}</td>
            <td>${item.resolution_date}</td>
          </tr>
        `;
      });
      
      html += `
            </tbody>
          </table>
        </body>
        </html>
      `;
      
      printWindow.document.write(html);
      printWindow.document.close();
      printWindow.focus();
      
      // 等待内容加载完成后打印
      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 500);
    },

    // 获取搜索条件文本
    getSearchConditionsText() {
      const conditions = [];
      
      if (this.query.fac_type) {
        conditions.push(`设备类型: ${this.getDeviceTypeName(this.query.fac_type)}`);
      }
      if (this.query.factory_area) {
        conditions.push(`所属厂区: ${this.query.factory_area}`);
      }
      if (this.query.building_number) {
        conditions.push(`所属楼号: ${this.query.building_number}`);
      }
      if (this.query.floor) {
        conditions.push(`所属楼层: ${this.query.floor}`);
      }
      if (this.query.start_date) {
        conditions.push(`开始日期: ${this.query.start_date}`);
      }
      if (this.query.end_date) {
        conditions.push(`结束日期: ${this.query.end_date}`);
      }
      if (this.query.fac_name) {
        conditions.push(`设备名称: ${this.query.fac_name}`);
      }
      if (this.query.install_area) {
        conditions.push(`安装位置: ${this.query.install_area}`);
      }
      
      return conditions.length > 0 ? conditions.join(', ') : '无筛选条件';
    },

    // 获取状态样式类
    getStatusClass(status) {
      if (status === '待处理') return 'status-pending';
      if (status === '已处理') return 'status-processed';
      if (status === '已解决') return 'status-resolved';
      if (status === '已关闭') return 'status-closed';
      return 'status-unknown';
    }
  }
}
</script>

<style scoped>
.loading {
  text-align: center;
  padding: 20px;
  color: #666;
}

.loading::before {
  content: "...";
  margin-right: 8px;
}

/* 弹窗样式 */
.edit-form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.edit-form-centered {
  max-width: 600px;
  margin: 0 auto;
}

.edit-form-row {
  display: flex;
  align-items: center;
  justify-content: center;
}

.edit-form-row label {
  color: #222;
  font-size: 16px;
  min-width: 120px;
  text-align: right;
  margin-right: 12px;
}

.edit-form-row .form-input {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 15px;
  width: 200px;
  min-width: 200px;
  outline: none;
  transition: border 0.2s;
}

.edit-form-row .form-input:focus {
  border: 1.5px solid #4caf50;
}

.edit-form-row select.form-input {
  min-width: 200px;
}

.edit-form-row input[type="date"].form-input {
  min-width: 200px;
}

.edit-form-row textarea.form-input {
  min-width: 200px;
  resize: vertical;
}

.required {
  color: #e74c3c;
  margin-right: 4px;
}

/* 弹窗内容区域样式 */
.modal-content {
  max-height: 80vh;
  overflow-y: auto;
}

/* 响应式设 */
@media (max-width: 768px) {
  .edit-form-row {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .edit-form-row label {
    min-width: auto;
    margin-bottom: 8px;
  }
  
  .edit-form-row .form-input {
    min-width: 100%;
  }
}

/* 清空按钮样式 */
.clear-btn {
  background: #f5f5f5;
  color: #666;
  border: 1px solid #ddd;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  margin-left: 8px;
  transition: all 0.2s;
}
.save-btn {
  background: #4caf50;
  color: #fff;
  border: 1px solid #ddd;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  margin-left: 8px;
  transition: all 0.2s;
}
.save-btn:hover {
  background: #43a047;
  border-color: #fff;
}
.clear-btn:hover {
  background: #e8e8e8;
  border-color: #ccc;
}

/* 解决状态标签样式 */
.status-tag {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: bold;
  color: #fff;
  text-align: center;
}

.status-tag.resolved {
  background-color: #4caf50; /* 绿色 */
}

.status-tag.processed {
  background-color: #2196f3; /* 蓝色 */
}

.status-tag.closed {
  background-color: #f44336; /* 红色 */
}

</style>
